import { useEffect } from 'react';
import colors from '../theme/colors';

const EnvironmentIndicator = () => {
  const env = process.env.REACT_APP_DEPLOYMENT || 'local';

  useEffect(() => {
    document.body.setAttribute('data-env', env);
    return () => document.body.removeAttribute('data-env');
  }, [env]);

  return (
    <div style={{ height: '3px', width: '100%', backgroundColor: colors.primary }} />
  );
};

export default EnvironmentIndicator;
